
$(document).ready(function (e) {
  const year = new Date().getFullYear()
  $('.m_footer .current-year').html(year)
})

